import React, { useState } from "react";
import db from "./firebase";
import firebase from "firebase";
import cookie from 'react-cookies';
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';
import axios from "axios";
import { ColorRing } from 'react-loader-spinner'


function MyVerticallyCenteredModal(props) {


  const apiKey =process.env.REACT_APP_API_KEY
  const [note, setNote] = useState({
    title: "",
    content: ""
  });
  const userid = cookie.load("userid");
  function handleChange(event) {
    const { name, value } = event.target;
    setNote(prevNote => {
      return {
        ...prevNote,
        [name]: value
      };
    });
  }


  function submitNote() {
    if (note.title === "" && note.content === "") {
      props.onHide();
    }
    else {
      db.collection("users")
        .where('userid', '==', userid)
        .onSnapshot((snapshot) => {
          snapshot.docs.map((doc) => {
            db.collection('users')
              .doc(doc.id)
              .collection('Notes')
              .add({
                title: note.title,
                content: note.content,
                timestamp: firebase.firestore.FieldValue.serverTimestamp()
              });
            return 0;
          });
        });
      setNote({
        title: "",
        content: ""
      })
      setAnswers("hide-textarea");
      setQuestion("show-textarea");
    }
    props.onHide();
  }
  function close() {
    props.onHide();
    setShowProgress(false);
    setNote({
      title: "",
      content: ""

    })
  }

  const [answers, setAnswers] = useState("hide-textarea");
  const [question, setQuestion] = useState("show-textarea");

  const [showProgress, setShowProgress] = useState(false);

  const [inputDisabled, setInputDisabled] = useState(false);
  async function getAnswer() {

    setInputDisabled(true);
    setShowProgress(true);
    const augmentedPrompt = `${note.title}:${note.content}`

    const client = axios.create({
      headers: {
        Authorization: "Bearer " + apiKey,
      },
    });
    const params = {
      prompt: augmentedPrompt,
      model: "text-davinci-003",
      max_tokens: 2000,
      temperature: 0.9,
    };

    try {
      await client
        .post("https://api.openai.com/v1/completions", params)
        .then((result) => {
          console.log(result);
          setNote({
            title: note.title,
            content: result.data.choices[0].text
          });
          setAnswers("show-textarea");
          setQuestion("hide-textarea");
          // setResponse(result.data.choices[0].text);
        })
        .catch((err) => {
          setInputDisabled(false);
          console.log(err);
        });

    }
    catch (error) {
      console.error('Error calling OpenAI API:', error.message);
    }
    setShowProgress(false);
   
  }



  return (<div className="modal">
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-body-1"
    >
      <Modal.Title id="contained-modal-title-vcenter">
        <div className={` title-edit ${answers} `}>
          {note.title}
        </div>
        <input
          name="title"
          onChange={handleChange}
          value={note.title}
          placeholder="Enter Query here ..."
          className={` title-edit ${question} `}
          disabled={inputDisabled}
        />

      </Modal.Title>
      <Modal.Body >
        <div className={` text-area ${answers} `}>
          {note.content}
        </div>
        <ColorRing
          visible={showProgress}
          height="80"
          width="80"
          ariaLabel="blocks-loading"
          wrapperStyle={{}}
          wrapperClass="blocks-wrapper"
          colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
          className="loader"
        />
        <textarea
          name="content"
          onChange={handleChange}
          value={note.content}
          className={` text-area ${question}  `}
          placeholder="Enter Content here .... " 
          disabled={inputDisabled}
        />
      </Modal.Body>

      <div className="buttons-pop">
        <Button className="btn btn-secondary close" variant="primary" onClick={close}>
          Close
        </Button>
        {
          question === "show-textarea" ?
            <Button type="button" className="btn btn-secondary save-changes" onClick={getAnswer}> Submit </Button> :
            <Button className="btn btn-secondary save-changes" variant="primary" onClick={submitNote}>
              Add Notes
            </Button>
        }

      </div>
    </Modal>
  </div>
  );
}

function CreateArea() {

  const [modalShow, setModalShow] = React.useState(false);
  function active() {
    setModalShow(true);
  }
  function deactive() {
    setModalShow(false);
  }

  return (
    <div >
      <form className="create-note" onClick={active}>
        <textarea
          placeholder="Ask a question..."
          rows="1"
          disabled={true}
        />

      </form>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={deactive}
        title=""
        content=""
      />
    </div>

  );
}

export default CreateArea;
